<template>
  <a-modal
    title="题目显示设置"
    :width="600"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="取消"
    okText="确认"
  >
    <a-form :form="form" layout="vertical">
      <a-form-item label="选择父题">
        <a-select
          v-decorator="['parentQuestion', { rules: [{ required: true, message: '请选择父题' }] }]"
          placeholder="请选择父题"
          @change="handleParentQuestionChange"
        >
          <a-select-option
            v-for="question in parentQuestions"
            :key="question.key"
            :value="question.key"
          >
            {{ question.number }} {{ question.label }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="父题选项">
        <a-select
          v-decorator="['parentOptions', { rules: [{ required: true, message: '请选择父题选项' }] }]"
          placeholder="请选择父题选项"
          mode="multiple"
        >
          <a-select-option
            v-for="option in selectedParentOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'ParentChildRelationModal',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      parentQuestions: [],
      selectedParentOptions: [],
      currentRecord: null
    };
  },
  methods: {
    show(parentQuestions, record) {

      if (parentQuestions && parentQuestions.length > 0) {
        // console.log('Parent questions details:', parentQuestions);
      }
      this.parentQuestions = parentQuestions;
      this.currentRecord = record;
      this.$set(this, 'visible', true);


      // 清空之前的选择
      this.selectedParentOptions = [];
      
      // 如果当前记录已有关联配置，则填充表单
      this.$nextTick(() => {

        const formValues = {};
        
        // 检查当前记录是否有关联配置
        if (this.currentRecord && this.currentRecord.common) {
          // 检查是否有父子关系数据
          const hasParentRelation = this.currentRecord.common.parentCode || this.currentRecord.common.parentValue;
          
          if (hasParentRelation) {
            // 有父子关系数据，填充表单
            if (this.currentRecord.common.parentCode) {
              // 根据code查找对应的父题key
              const selectedQuestion = this.parentQuestions.find(q => q.code === this.currentRecord.common.parentCode);
              if (selectedQuestion) {
                formValues.parentQuestion = selectedQuestion.key;
                this.selectedParentOptions = selectedQuestion.options;
              } else {
                // console.log('No matching parent question found');
              }
            }
            
            // 从parentValue字段读取数据
            if (this.currentRecord.common.parentValue) {
              formValues.parentOptions = this.currentRecord.common.parentValue.split(',');
            }
          } else {
            // 没有父子关系数据，确保表单字段为空
            formValues.parentQuestion = undefined;
            formValues.parentOptions = undefined;
          }
        } else {
          // 没有common字段，确保表单字段为空
          formValues.parentQuestion = undefined;
          formValues.parentOptions = undefined;
        }
        
        this.form.setFieldsValue(formValues);
      });
    },

    handleParentQuestionChange(parentQuestionKey) {
      // 根据选择的父题更新选项列表
      const selectedQuestion = this.parentQuestions.find(q => q.key === parentQuestionKey);
      if (selectedQuestion) {
        this.selectedParentOptions = selectedQuestion.options;
      } else {
        this.selectedParentOptions = [];
      }
      
      // 清空已选择的选项值
      this.form.setFieldsValue({
        parentOptions: undefined
      });;
    },

    handleOk() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          // 返回配置数据
          this.$emit('save', values);
          this.$set(this, 'visible', false);
        } else {
          // console.log('ParentChildRelationModal validation errors:', errors);
        }
      });
    },

    handleCancel() {
      this.$set(this, 'visible', false);
    }
  }
};
</script>

<style scoped>
/* 可以添加一些样式 */
</style>